import { PropsWithChildren, createContext, useMemo, useState } from 'react';
import { SidenavContextValue, SidenavDispatchContextValue } from './type';

const INITIAL_CONTEXT_VALUE: SidenavContextValue = {
  openOptions: false,
  openOptionsPage: null,
};

const INITIAL_DISPATCH_CONTEXT_VALUE: SidenavDispatchContextValue = {
  setOpenOptions: () => null,
  setOpenOptionsPage: () => null,
};

export const DashboardSidenavContext = createContext<SidenavContextValue>(INITIAL_CONTEXT_VALUE);

export const DashboardSidenavDispatchContext = createContext<SidenavDispatchContextValue>(
  INITIAL_DISPATCH_CONTEXT_VALUE
);

export function DashboardSidenavContextProvider({ children }: PropsWithChildren) {
  const [openOptions, setOpenOptions] = useState(INITIAL_CONTEXT_VALUE.openOptions);
  const [openOptionsPage, setOpenOptionsPage] = useState<string | null>(
    INITIAL_CONTEXT_VALUE.openOptionsPage
  );

  const value = useMemo(
    () => ({
      openOptions,
      openOptionsPage,
    }),
    [openOptions, openOptionsPage]
  );

  const dispatchValue = useMemo(
    () => ({
      setOpenOptions,
      setOpenOptionsPage,
    }),
    []
  );

  return (
    <DashboardSidenavContext.Provider value={value}>
      <DashboardSidenavDispatchContext.Provider value={dispatchValue}>
        {children}
      </DashboardSidenavDispatchContext.Provider>
    </DashboardSidenavContext.Provider>
  );
}
